<template>
<v-container v-if="tournament">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{tournament.title}} </div>
      </v-col>
    </v-row>
  <v-row>
    <v-col>
      <div>Lugar: {{tournament.address}} <p v-if="tournament.city"> Ciudad: {{tournament.city}}</p></div>
    </v-col>
  </v-row>
    <v-row>
    <v-col cols="6" md="4">
      <div>Tipo: {{tournament.type}}</div>
    </v-col>
      <v-col cols="6" md="4">
      <div>Rondas: {{tournament.rounds}}</div>
    </v-col>
      <v-col cols="12" md="4">
      <div>Ritmo: {{tournament.time_control}}</div>
    </v-col>
  </v-row>
    <v-row>
    <v-col v-if="tournament.club">
      <div>Club: {{tournament.club.name}}</div>
    </v-col>
  </v-row>
    <v-row>
      <v-col v-if="tournament.max_inscriptions"  cols="12" md="4">
        <div style="font-size: 20px">Capacidad: {{tournament.max_inscriptions}}</div>
    </v-col>
    <v-col v-if="tournament.inscriptions_count || tournament.can_inscription" cols="12" md="4">
      <div style="font-size: 20px">
        <div>
          <a style="font-size: 20px; text-decoration: underline; color: #4cccc1" :href="'/inscritos/'+tournament.id"> Inscritos: {{tournament.inscriptions_count}}(ver)</a>
        </div>

      </div>
    </v-col>
      <v-col v-if="tournament.can_inscription" cols="12" md="4">
        <div style="font-size: 20px; text-decoration: underline; color: #4cccc1">
          <a :href="'/inscripcion/'+tournament.id">Inscribirse</a>
        </div>
    </v-col>
  </v-row>
  </div>
<div>

<br>
  <v-row>
    <v-col cols="10" offset-md="1">
      <div v-html="tournament.contentHtml" class="ck-content"></div>
    </v-col>
  </v-row>
  </div>
</v-container>

</template>
<script>


import gql from "graphql-tag";
export default {
  apollo: {
    tournament: {query: gql` query($id:String!){
       tournament(id:$id){
        id
        title
        type
        address
        contentHtml
        club {
          name
        }
        time_control:timeControl
        rounds
        city
        can_inscription:canInscription
        inscriptions_count:inscriptionsCount
        max_inscriptions:maxInscriptions
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  props:['id'],
    name:"SeeNewsChess",
  data() {

    return {
      tournament: null,
    }
  },
  components: {

  },
  computed:{
    info_t(){
      return JSON.parse(this.tournament.content)
    }
  },
  methods: {
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
  },
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
